import { ILogger } from '../../domain/interfaces/ILogger';

export class ConsoleLogger implements ILogger {
  debug(message: string, ...args: any[]): void {
    console.debug(`[StackScope] ${message}`, ...args);
  }

  info(message: string, ...args: any[]): void {
    console.info(`[StackScope] ${message}`, ...args);
  }

  warn(message: string, ...args: any[]): void {
    console.warn(`[StackScope] ${message}`, ...args);
  }

  error(message: string, error?: Error, ...args: any[]): void {
    if (error) {
      console.error(`[StackScope] ${message}`, error, ...args);
    } else {
      console.error(`[StackScope] ${message}`, ...args);
    }
  }
}